import { render, staticRenderFns } from "./EnablingFarmers.vue?vue&type=template&id=08cd8486&scoped=true&"
import script from "./EnablingFarmers.vue?vue&type=script&lang=js&"
export * from "./EnablingFarmers.vue?vue&type=script&lang=js&"
import style0 from "./EnablingFarmers.vue?vue&type=style&index=0&id=08cd8486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd8486",
  null
  
)

export default component.exports